module.exports = __webpack_public_path__ + "static/AngelaHe2-8340b1c79d0dfda3398440060062c759.webp";